import { ParameterEntity } from "../../../misc/api/SerenityReferenceData";
import { ISelectListItem } from "../../../misc/AspnetSelectList";

export const ConvertToSelectListItemArray = (params: number[], parameterResponse: ParameterEntity[]) => {
    return params && params.length > 0
        ? parameterResponse.filter(p => params.includes(p.Id)).map(p => {
            return { 
                Id: p.Id,
                Value: p.Keyword, 
                Text: p.DisplayName + (p.UnitName ? ` (${p.UnitName})` : ''), 
                Group: null, 
                Selected: false, 
                Disabled: false 
            };
        })
        : null;
}

export const ConvertToIdsArray = (params: ISelectListItem[], parameterResponse: ParameterEntity[]) => {
    return params && params.length > 0
            ? parameterResponse.filter(p => params.map(s => s.Value).includes(p.Keyword)).map(p => p.Id)
            : null;
}
